import { Controller } from "react-hook-form/dist/index.ie11";
import ErrorMessage from "./ErrorMessage/ErrorMessage";
import Label from "./Label/Label";
import { useFormContext } from "./FormProvider";
import { v4 as uuidv4 } from "uuid";

const UUID = uuidv4();

StandardInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  rules: PropTypes.object,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  checked: PropTypes.bool,
};

StandardInput.defaultProps = {
  name: "input",
  label: "Label",
  defaultValue: "",
  className: "",
  value: "",
};

export default function StandardInput({
  name,
  label,
  rules,
  className,
  disabled,
  checked,
}) {
  const { control, errors } = useFormContext();
  const id = `${name}__${UUID}`;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={checked}
      render={({ onChange, value = "" }) => (
        <div className={"field field-checkbox" + className}>
          <div className={"control"}>
            <input
              id={id}
              disabled={disabled}
              onChange={(e) => onChange(e.target.checked)}
              type={"checkbox"}
              name={name}
              value={value}
              checked={value}
              className={"checkbox"}
            />
            <div className={"checkbox-toggle"}>
              <div />
            </div>
          </div>

          <Label value={label} htmlFor={id} />
          <ErrorMessage error={errors[name]} />
        </div>
      )}
    />
  );
}
